var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeOpenImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 4,
    stroke: "#ffffff",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.1991 12.9271C25.5828 13.4096 25.7746 13.6509 25.7746 14C25.7746 14.3491 25.5828 14.5904 25.1991 15.0729C23.465 17.2538 19.1047 22 14 22C8.89527 22 4.53501 17.2538 2.80088 15.0729C2.41723 14.5904 2.22541 14.3491 2.22541 14C2.22541 13.6509 2.41723 13.4096 2.80088 12.9271C4.53501 10.7462 8.89527 6 14 6C19.1047 6 23.465 10.7462 25.1991 12.9271Z",
    stroke: "#ffffff",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOpenImg);
export default __webpack_public_path__ + "static/media/eye_open_img.b63af6ffb2a523c7124b3ea576d49ec6.svg";
export { ForwardRef as ReactComponent };